import { motion } from 'framer-motion';

const BeforeAfterSection = () => {
  return (
    <section id="before-after" className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">
            墓じまいのビフォーアフター
          </h2>
          <p className="text-lg text-stone-600">
            長年守ってきたお墓を、感謝を込めて更地に還します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Before */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative group"
          >
            <div className="absolute top-4 left-4 bg-stone-800/80 text-white px-4 py-1 rounded-full text-sm font-bold z-10 backdrop-blur-sm">
              Before
            </div>
            <div className="aspect-[4/3] overflow-hidden rounded-2xl shadow-lg">
              <img
                src="images/before.jpg"
                alt="墓じまい前の様子"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <p className="mt-4 text-stone-700 font-bold text-lg text-center">
              施工前のお墓の様子
            </p>
          </motion.div>

          {/* After */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative group"
          >
            <div className="absolute top-4 left-4 bg-amber-600/90 text-white px-4 py-1 rounded-full text-sm font-bold z-10 backdrop-blur-sm">
              After
            </div>
            <div className="aspect-[4/3] overflow-hidden rounded-2xl shadow-lg border-2 border-amber-100">
              <img
                src="images/after.jpg"
                alt="墓じまい後の更地の様子"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <p className="mt-4 text-stone-700 font-bold text-lg text-center">
              墓石撤去・整地後の様子
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
